<template>
  <auth-layout pageClass="lock-page">
    <loading :active.sync="isLoading"
      :can-cancel="false"
      :color="'#f18f00'"
      :is-full-page="false"
      :height="80"
      :width="155"
      :opacity="0.8">
    </loading>
    <div class="content">
      <form method="POST" @submit.prevent="validateSubmit">
        <div class="user-profile">
          <div class="author">
            <span v-if="user_store">
              <img v-if="user_store.avatar" class="avatar border-gray" :src="user_store.avatar" alt="...">
              <img v-else class="avatar border-gray" src="/static/img/avatar-dafult.svg">
            </span>
            <span v-else>
              <span v-if="user_local">
                <img v-if="user_local.avatar" class="avatar border-gray" :src="user_local.avatar" alt="...">
                <img v-else class="avatar border-gray" src="/static/img/avatar-dafult.svg">
              </span>
            </span>
          </div>
          <h4 v-if="user_store">{{ user_store.first_name }} {{ user_store.last_name }}</h4>
          <h4 v-else-if="user_local">{{ user_local.name }}</h4>
          <fg-input class="hiddenfg"></fg-input>
          <fg-input
            placeholder="Ingrese su contraseña"
            v-validate="modelValidations.password"
            name="contraseña"
            :error="getError('contraseña')"
            v-model="user.password"
            v-on:keyup="validateKey"
            :type="showPass.inputTypePass"
            :myCustom="{addon : 'not-input-group-addon'}">
            <template slot="addonRight">
              <l-button @click="showPassword">
                <em :class="showPass.iconBtnPass"></em>
              </l-button>
            </template>
          </fg-input>
          <button type="submit" class="btn btn-primary btn-wd">Desbloquear</button>
          <button type="button" class="btn btn-add btn-wd" @click.prevent="signout">Cerrar Sesión</button>
        </div>
      </form>
    </div>
  </auth-layout>
</template>
<script>
  import mixinAuth from 'src/util/mixinAuth'
  import { mapActions, mapGetters } from 'vuex'
  import showSwalAlert from 'src/util/alerts'
  import store from '@/store'
  import Loading from 'vue-loading-overlay';
  import 'vue-loading-overlay/dist/vue-loading.css';

  export default {
    components:{
      Loading,
    },

    data(){
      return {
        isLoading: false,
        user_local: null
      }
    },
    computed: {
      ...mapGetters({
        user_store: 'auth/user'
      })
    },
    mixins: [mixinAuth],
    methods: {
      ...mapActions({
        logout: 'auth/logout',
        cleanUserlogout: 'auth/cleanUserlogout',
      }),
      validateSubmit () {
        this.$validator.validateAll().then(isValid => {
          if(isValid) {
            this.user.login = this.user_local.user
            this.signin()
          }
        })
      },
      // este metodo se encagar de llamar nuestra accion login del store
      signin (){
        this.isLoading = true
        this.login(this.user).then((response) => {
          localStorage.removeItem('user')
          this.$router.push('/').catch(() => {
            this.isLoading = false
            if(response.data.success == 200) this.passRequestEmail({ login: response.data.data, password_temporary: true })
          })
        }).catch((error) => {
          this.isLoading = false
          if(error.response.data.message) showSwalAlert(error.response.data.message, 'error', false)
        })
      },
      signout () {
        this.isLoading = true
        this.cleanUserlogout()
        localStorage.removeItem('user')        
        localStorage.removeItem('token')        
        this.$router.push('/login')
        this.isLoading = false
      }, 
    },
    created(){
      if(localStorage.getItem('user')){
        this.user_local = JSON.parse(localStorage.getItem('user'))
      }
    },
    mounted(){
      var mouseStop = null;
      document.addEventListener('mousemove', () => {
        clearTimeout(mouseStop)
        mouseStop = setTimeout(() => {
          if( this.$route.name != 'Login' && this.$route.name != 'PasswordReset'){
            store.dispatch('auth/cleanUserlogout')
            showSwalAlert(
              'Has durado mucho tiempo inactivo y bloqueado, has sido desconectado.',
              'warning',
              false
            )
            localStorage.removeItem('user')
            this.$router.push('/login').catch((e)=>{console.log(e)})
          }
        }, 7200000)
      })
    }
  }
</script>
<style>
.hiddenfg{
  display: none;
}
.invalid-feedback{
  background-color: white !important;
  padding: 10px;
}
</style>
